import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAllTags } from '../../utils/blogUtils';
import TagsList from './TagsList';
import '../../assets/styles/Blog.css';

const BlogSearch: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [tags, setTags] = useState<string[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Parse current query parameters
  const searchParams = new URLSearchParams(location.search);
  const currentQuery = searchParams.get('query') || '';
  const currentTag = searchParams.get('tag') || '';

  // Update search term when the query parameter changes
  useEffect(() => {
    setSearchTerm(currentQuery);
  }, [currentQuery]);

  // Load all available tags
  useEffect(() => {
    const loadTags = async () => {
      const allTags = await getAllTags();
      setTags(allTags);
    };
    
    loadTags();
  }, []);

  // Handle search form submission
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    
    const params = new URLSearchParams();
    if (searchTerm) {
      params.set('query', searchTerm);
    }
    if (currentTag) {
      params.set('tag', currentTag);
    }
    
    navigate(`/blog?${params.toString()}`);
  };

  // Handle tag selection
  const handleTagClick = (tag: string) => {
    const params = new URLSearchParams();
    if (currentQuery) {
      params.set('query', currentQuery);
    }
    
    // If the tag is already selected, remove it
    // Otherwise, set it as the current tag
    if (tag === currentTag) {
      // Tag is already selected, remove it
    } else {
      params.set('tag', tag);
    }
    
    navigate(`/blog?${params.toString()}`);
  };

  return (
    <div className="blog-search-container">
      <div className="blog-search">
        <form className="blog-search-form" onSubmit={handleSearch}>
          <input
            type="text"
            className="blog-search-input"
            placeholder="Search blog posts..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="blog-search-button-container">
            <button type="submit" className="blog-search-button">
              Search
            </button>
          </div>
        </form>
      </div>
      
      {tags.length > 0 && (
        <div className="blog-tags-section">
          <TagsList 
            tags={tags} 
            selectedTag={currentTag} 
            onTagSelect={handleTagClick} 
          />
        </div>
      )}
    </div>
  );
};

export default BlogSearch; 